<p *ngIf="lastUpdated" [ngClass]="getClasses()">Zuletzt aktualisiert am {{ lastUpdated|date:'dd.MM.YYYY.' }}</p>
